import { Card, CardContent, Typography } from '@material-ui/core';
import { motion } from 'framer-motion';

const ComingSoonCard = () => {
  return (
    <div className="flex flex-col flex-auto items-center justify-center p-16 sm:p-32">
      <div className="flex flex-col items-center justify-center w-full">
        <motion.div initial={{ opacity: 0, scale: 0.6 }} animate={{ opacity: 1, scale: 1 }}>
          <Card className="w-400" elevation={8}>
            <CardContent className="flex flex-col items-center justify-center p-16 sm:p-32 text-center">
              <img className="w-256 mb-24" src="assets/images/logos/turp-01.svg" alt="logo" />

              <Typography variant="h6" className="font-semibold">
                Bu sayfa henüz hazır değil...
              </Typography>

              <Typography variant="subtitle1" color="textSecondary" className="max-w-320 my-32">
                Çalışmalarımız devam ediyor 😎👍
              </Typography>
            </CardContent>
          </Card>
        </motion.div>
      </div>
    </div>
  );
};

export default ComingSoonCard;
